/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Defaultsort2Inputs */

const id_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutan Default`)
};

const ms_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunan Lalai`)
};

const da_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardsortering`)
};

const de_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardsortierung`)
};

const en_us2_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default Sort`)
};

const es_es2_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orden predeterminado`)
};

const es_mx2_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orden predeterminado`)
};

const fil_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default na Pagkakasunod`)
};

const fr_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tri par défaut`)
};

const it_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordinamento predefinito`)
};

const hu_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alapértelmezett rendezés`)
};

const nl_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standaard sortering`)
};

const no_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard sortering`)
};

const pl_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domyślne sortowanie`)
};

const pt_br2_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação padrão`)
};

const pt_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenação predefinida`)
};

const ro_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortare implicită`)
};

const fi_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oletusjärjestys`)
};

const sv_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardsortering`)
};

const vi_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp mặc định`)
};

const tr_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varsayılan Sıralama`)
};

const cs_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí řazení`)
};

const bg_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартно сортиране`)
};

const ru_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировка по умолчанию`)
};

const uk_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортування за замовчуванням`)
};

const ar_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترتيب الافتراضي`)
};

const hi_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिफ़ॉल्ट क्रम`)
};

const th_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียงลำดับเริ่มต้น`)
};

const ja_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デフォルト順`)
};

const zh_cn2_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认排序`)
};

const zh_hant1_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`預設排序`)
};

const ko_offerdetail_achievements_defaultsort2 = /** @type {(inputs: Offerdetail_Achievements_Defaultsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본 정렬`)
};

/**
* | output |
* | --- |
* | "Default Sort" |
*
* @param {Offerdetail_Achievements_Defaultsort2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_defaultsort2 = /** @type {((inputs?: Offerdetail_Achievements_Defaultsort2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Defaultsort2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "da") return da_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "de") return de_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "it") return it_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "no") return no_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "th") return th_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_defaultsort2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_defaultsort2(inputs)
	return ko_offerdetail_achievements_defaultsort2(inputs)
});
export { offerdetail_achievements_defaultsort2 as "offerDetail.achievements.defaultSort" }